// src/firebase-config.js

import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// TBQ project – used for Auth, Users, Attempts, Quiz, Centers
const tbqConfig = {
    apiKey: "AIzaSyC1adEhvnFhy-XM4PeKO2IAxYlDEeNhV5k",
    authDomain: "tazkeer-bil-quran-c9430.firebaseapp.com",
    projectId: "tazkeer-bil-quran-c9430",
    storageBucket: "tazkeer-bil-quran-c9430.appspot.com",
    messagingSenderId: "650780588557",
    appId: "1:650780588557:web:df5c83b63cc6ee10ea7344",
    measurementId: "G-VG9D9GC1VK"
};

// DTQ All-Purpose project – used for DTQ Locations (the Flutter app's data)
const dtqConfig = {
    apiKey: "AIzaSyB6W5o5Sid_mkk5vz2jcBmzaaz6_VRFOgU",
    authDomain: "dtq-all-purpose.firebaseapp.com",
    projectId: "dtq-all-purpose",
    storageBucket: "dtq-all-purpose.appspot.com",
    messagingSenderId: "714185545027",
    appId: "1:714185545027:android:f94f75448197818887cbf6",
};

// Avoid duplicate-app errors during hot reload in development.
const tbqApp = getApps().some((app) => app.name === "[DEFAULT]")
  ? getApp()
  : initializeApp(tbqConfig);
const dtqApp = getApps().some((app) => app.name === "dtq")
  ? getApp("dtq")
  : initializeApp(dtqConfig, "dtq");

// TBQ exports (auth, users, attempts)
export const auth = getAuth(tbqApp);
export const db = getFirestore(tbqApp);
export const tbqFunctions = getFunctions(tbqApp);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

// DTQ exports (DTQ Locations)
export const dtqAuth = getAuth(dtqApp);
export const dtqDb = getFirestore(dtqApp);
